import { makeStyles } from '@material-ui/core/styles'

export const useOrdersTableStyles = makeStyles(() => ({
  paper: {
    minWidth: 1280,
    boxShadow: 'unset',
  },
  tableContainer: {
    width: 'calc(100vw - 300px)',
  },
  table: {
    minWidth: 1580,
    fontSize: 12,
    color: '#5f5f5f',
  },
}))
